module.exports = __webpack_public_path__ + "img/logo-curitiba.6bd990db.png";